module.exports = __webpack_public_path__ + "static/media/sadCalendar.f412b3fc.PNG";